import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import { Constants } from 'src/app/_consts/constants';
import { SInputComponent } from '../s-input/s-input.component';
import { STableComponent } from '../s-table/s-table.component';

@Component({
  selector: 'app-date-range-btns',
  templateUrl: './date-range-btns.component.html',
  styleUrls: ['./date-range-btns.component.scss'],
  imports: [CommonModule, TranslateModule, NgbModule, SInputComponent]
})
export class DateRangeBtnsComponent implements OnInit {

  @Input() table: STableComponent
  @Input() defType: any
  @Input() size: string = "sm"
  @Input() allowAll: boolean = true
  @Output() change = new EventEmitter();

  public dateFrom: Date;
  public dateTo: Date;
  inputClass
  btnClass

  btns = Constants.DATE_FILTER_BTNS;

  constructor() {
  }

  ngOnInit(): void {
    if (!this.allowAll)
      this.btns = this.btns.filter(b => b !== 'all')
    if (this.defType)
      this.selectDates(this.defType)

    switch (this.size) {
      case 'sm':
        this.inputClass = 'form-control-sm'
        this.btnClass = 'btn-sm'
        break;
      case 'md':
        this.inputClass = 'form-control'
        this.btnClass = 'btn-sm'
        break;
      case 'lg':
        this.inputClass = 'form-control-lg'
        this.btnClass = 'btn-md'
        break;
    }
  }

  public fromToChange() {
    this.setTableParamsAndRefresh(this.table)
    this.change.emit({ dateFrom: this.dateFrom, dateTo: this.dateTo })
  }

  setTableParamsAndRefresh(table: STableComponent) {
    if (table) {
      if (!table.customSearch)
        table.customSearch = {};

      table.customSearch.range_from = this.dateFrom ? moment(this.dateFrom).startOf('day').toDate() : null
      table.customSearch.range_to = this.dateTo ? moment(this.dateTo).endOf('day').toDate() : null

      requestAnimationFrame(() => {
        table?.refresh(true);
      })
    }
  }

  clear() {
    this.dateFrom = null;
    this.dateTo = null;
    this.fromToChange()
  }

  selectDates(type, onlyIfEmpty = false) {
    if (this.table && !this.table.customSearch)
      this.table.customSearch = {};
    console.log("SELECTED", type);


    if (this.dateFrom && this.dateTo && this.dateTo < this.dateFrom)
      this.dateTo = this.dateFrom

    if (!type) {
      this.fromToChange()
      return;
    }

    if (onlyIfEmpty && this.dateFrom && this.dateTo) {
      this.fromToChange()
      return;
    }

    const dateFrom = moment().startOf('day')
    const dateTo = moment().endOf('day')

    switch (type) {
      case "today":
        break;
      case "yesterday":
        dateFrom.add(-1, 'day')
        dateTo.add(-1, 'day')
        break;
      case "this_week":
        dateFrom.startOf('isoWeek')
        dateTo.endOf('isoWeek')
        break;
      case "last_week":
        dateFrom.add(-1, 'week').startOf('isoWeek')
        dateTo.add(-1, 'week').endOf('isoWeek')
        break;
      case "this_month":
        dateFrom.startOf('month')
        dateTo.endOf('month')
        break;
      case "last_month":
        dateFrom.add(-1, 'month').startOf('month')
        dateTo.add(-1, 'month').endOf('month')
        break;
      case "this_year":
        dateFrom.startOf('year')
        dateTo.endOf('year')
        break;
      case "last_year":
        dateFrom.add(-1, 'year').startOf('year')
        dateTo.add(-1, 'year').endOf('year')
        break;
      case "all":
        this.clear()
        return;
        break;
    }
    this.dateFrom = dateFrom.toDate()
    this.dateTo = dateTo.toDate()
    this.fromToChange()
  }



}
